var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "64px",
    height: "64px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 29,
    y1: 31.5,
    x2: 29,
    y2: 38.5,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004aad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 29,
    y1: 7.167,
    x2: 29,
    y2: 58.176,
    gradientUnits: "userSpaceOnUse",
    id: "color-2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004aad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 46,
    y1: 7.167,
    x2: 46,
    y2: 58.176,
    gradientUnits: "userSpaceOnUse",
    id: "color-3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004aad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 33,
    y1: 7.167,
    x2: 33,
    y2: 58.176,
    gradientUnits: "userSpaceOnUse",
    id: "color-4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004aad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c52ff"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4,4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,37c0,0.552 -0.448,1 -1,1h-4c-0.552,0 -1,-0.448 -1,-1v-4c0,-0.552 0.448,-1 1,-1h4c0.552,0 1,0.448 1,1z",
    fill: "url(#color-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,34h-4c-1.103,0 -2,0.897 -2,2v12h-26v-26h12c1.103,0 2,-0.897 2,-2v-4c0,-1.103 -0.897,-2 -2,-2h-15c-2.757,0 -5,2.243 -5,5v32c0,2.757 2.243,5 5,5h32c2.757,0 5,-2.243 5,-5v-15c0,-1.103 -0.897,-2 -2,-2zM48,51c0,1.654 -1.346,3 -3,3h-32c-1.654,0 -3,-1.346 -3,-3v-32c0,-1.654 1.346,-3 3,-3h15v4h-12c-1.103,0 -2,0.897 -2,2v26c0,1.103 0.897,2 2,2h26c1.103,0 2,-0.897 2,-2v-12h4z",
    fill: "url(#color-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,8h-13c-1.103,0 -2,0.897 -2,2v4c0,1.103 0.897,2 2,2h10v10c0,1.103 0.897,2 2,2h4c1.103,0 2,-0.897 2,-2v-13c0,-2.757 -2.243,-5 -5,-5zM54,26h-4v-10c0,-1.103 -0.897,-2 -2,-2h-10v-4h13c1.654,0 3,1.346 3,3z",
    fill: "url(#color-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,28h-10c-1.103,0 -2,0.897 -2,2v10c0,1.103 0.897,2 2,2h10c1.103,0 2,-0.897 2,-2v-10c0,-0.178 -0.031,-0.347 -0.075,-0.511l6.075,-6.075v6.586h2v-8c0,-1.103 -0.897,-2 -2,-2h-8v2h6.586l-6.075,6.074c-0.164,-0.043 -0.333,-0.074 -0.511,-0.074zM34,40h-10v-10h10z",
    fill: "url(#color-4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.153b3edd47113b246ff4ba9ec841755b.svg";
export { ForwardRef as ReactComponent };